<template>
  <div>
    <div class="top-area">
      <div class="container">
        <el-row :gutter="20" type="flex" align="middle">
          <el-col :span="12" :offset="0" class="top-area-image-col">
            <img class="top-area-image" src="https://www.lydiasarfati.com/wp-content/uploads/2022/08/banner-3-1.jpg">
          </el-col>
          <el-col :span="12" :offset="0">
            <h1 class="page-title">Lydia Sarfati Blog for Skin Care Professionals</h1>
            <div class="page-sub-title">Everything You Need to Know About Esthetics and the Skin Care Industry</div>
            <div class="search-area">
              <div class="search-wrap">
                <input class="search-input" type="text" v-model="keyword" placeholder="通过标题中关键词搜索...">
                <i class="el-icon-search search-icon" @click="search()"></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="article-list-area container">
      <el-row :gutter="20">
        <el-col :span="8" :offset="0" v-for="(blog, index) in blogs" :key="index">
          <div>
            <div class="blog-title" @click="gotoDetail(blog.id)">{{blog.title}}</div>
            <el-image class="cover-image" :src="blog.image" fit="cover" @click="gotoDetail(blog.id)"></el-image>
            <div class="blog-des">{{blog.des}}</div>
            <div class="read-more" @click="gotoDetail(blog.id)">Read More</div>
          </div>
        </el-col>
      </el-row>
      <el-empty description="未找到任何文章" v-if="blogs!=undefined && blogs.length < 1"></el-empty>
    </div>
    <div class="g-page-area">
      <el-pagination @current-change="currentPageChange" :current-page.sync="page" :page-size="9" layout="total, prev, pager, next" :total="total" background></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      blogs: undefined,
      total: 0,
      page: 1,
      keyword: ''
    }
  },
  methods: {
    search () {
      this.page = 1
      this.getBlogs(1)
    },
    currentPageChange (page) {
      this.getBlogs(page)
    },
    getBlogs (page) {
      const that = this
      that.axios.get('blogs', { params: { page, keyword: that.keyword } }).then(function (resp) {
        if (resp.data.code === 0) {
          that.total = resp.data.total
          that.blogs = resp.data.blogs
        }
      })
    },
    gotoDetail (id) {
      this.$router.push({ path: '/news/blog/' + id })
    }
  },
  mounted () {
    console.log('mounte')
    this.getBlogs(1)
  }
}
</script>

<style scoped>
.top-area-image-col{
  line-height: 0;
}
*{
  box-sizing: border-box;
}
.top-area{
  background-color: #afe2e3;
}
.top-area-image{
  width: 100%;
}
.container{
  max-width: 1200px;
  margin: 0 auto;
}
.page-title{
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  font-family: Baskervville;
  padding: 20px 5px;
}
.page-sub-title{
  font-size: 24px;
  font-weight: 300;
  padding: 20px 20px;
  text-align: center;
}
.search-area{
  padding: 20px;
}
.search-wrap{
  display: flex;
  align-items: center;
  border-radius: 5px;
  width: 100%;
  background-color: #909399;
  border: 2px solid #303133;
}
.search-wrap:hover{
  background-color: #303133;
}
.search-input{
  font-size: 17px;
  padding: 10px;
  border: none;
  flex: 1;
  outline: none;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.search-icon{
  font-size: 20px;
  color: #fff;
  font-weight: bolder;
  cursor: pointer;
  width: 50px;
  text-align: center;
}
.article-list-area{
  padding: 50px 10px;
}
.blog-title{
  cursor: pointer;
  font-size: 20px;
  line-height: 50px;
  font-weight: 800;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  display:-webkit-box;
  -webkit-line-clamp: 1;/*行数*/
  -webkit-box-orient: vertical;
}
.blog-des{
  font-size: 17px;
  color: #595f5f;
  line-height: 25px;
  text-align: justify;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display:-webkit-box;
  -webkit-line-clamp: 4;/*行数*/
  -webkit-box-orient: vertical;
}
.cover-image{
  height: 300px;
  width: 100%;
}
.read-more{
  padding: 10px;
  margin: 10px 0;
  font-size: 13px;
  font-style: italic;
  color: #fff;
  background-color: #007882;
  display: inline-block;
  cursor: pointer;
}
</style>
